import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Image} from './image';

@Injectable({
  providedIn: 'root'
})
export class MainLightboxService {
  selectedImageIndex: BehaviorSubject<number> = new BehaviorSubject(null);
  images: BehaviorSubject<Image[]> = new BehaviorSubject([]);
  show: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showArrow: BehaviorSubject<boolean> = new BehaviorSubject(false);
  arrowClicked: BehaviorSubject<'previous' | 'next'> = new BehaviorSubject(null);
  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);

  open(images: Image[], index = 0, showArrowsAnyway = false) {
    this.images.next(images);
    this.selectedImageIndex.next(index);
    this.show.next(true);
    if (images.length > 1 || showArrowsAnyway) {
      this.showArrow.next(true);
    } else {
      this.showArrow.next(false);
    }
  }

  clickSwitchButton(i) {
    this.selectedImageIndex.next(i);
  }

  constructor() {
  }

  iterateImage(eventName) {
    if (eventName === 'next') {
      const indexNext = this.selectedImageIndex.value + 1;
      if (indexNext >= this.images.value.length) {
        this.selectedImageIndex.next(0);
      } else {
        this.selectedImageIndex.next(indexNext);
      }
    }
    if (eventName === 'previous') {
      const indexPrev = this.selectedImageIndex.value - 1;
      if (indexPrev < 0) {
        this.selectedImageIndex.next(this.images.value.length - 1);
      } else {
        this.selectedImageIndex.next(indexPrev);
      }
    }
    this.arrowClicked.next(eventName);
  }
}
